// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"660":"8f83ae16","775":"863abe6b"}[chunkId] + ".chunk.js";
};